import {Dialog, DialogBody, DialogClose, DialogContent, DialogFooter, DialogHeader, DialogTitle} from '../ui/dialog'
import {XMarkIcon} from '@heroicons/react/16/solid'
import {Button} from '../ui/button'
import React, {useState} from 'react'
import useAppStore from '@/store/useAppStore'

export interface ArchiveVaultValues {
    new_income_default_vault: any
    transfer_balance_to: any
}

export default function UnableToArchive() {
    const modalWindowState = useAppStore((state) => state.modalWindowState)
    const setModalWindowState = useAppStore((state) => state.setModalWindowState)

return (
        <Dialog open={modalWindowState === 'opened'}>
            <DialogContent>
                <DialogHeader>
                    <DialogTitle>Unable to Archive Vault</DialogTitle>
                    <DialogClose>
                        <XMarkIcon onClick={()=> setModalWindowState('closed')}/>
                    </DialogClose>
                </DialogHeader>

                <DialogBody>
                    <p>
                        You cannot archive this Vault because it is the only one you have. At least one active Vault is required. Please create a new Vault before archiving this one.
                    </p>
                </DialogBody>

                <DialogFooter>
                        <div>
                            <DialogClose asChild>
                                <Button onClick={()=> setModalWindowState('closed')} variant="secondary" className='mr-2'>
                                    Cancel
                                </Button>
                            </DialogClose>
                        </div>
                </DialogFooter>
            </DialogContent>
        </Dialog>
)
}
